import type { TenantBrandingValue } from '../components/TenantBrandingFields';

/** RGB variables let existing Tailwind utilities retain opacity and hover states. */
export function tenantThemeVariables(branding?: TenantBrandingValue): Record<string, string> {
  const variables: Record<string, string> = {};
  for (const [palette, hex] of [['primary', branding?.colore_primario], ['secondary', branding?.colore_secondario]] as const) {
    if (!hex || !/^#[0-9a-f]{6}$/i.test(hex)) continue;
    const channels = [1, 3, 5].map((start) => parseInt(hex.slice(start, start + 2), 16));
    const linear = channels.map((channel) => { const c = channel / 255; return c <= .04045 ? c / 12.92 : ((c + .055) / 1.055) ** 2.4; });
    const luminance = .2126 * linear[0] + .7152 * linear[1] + .0722 * linear[2];
    variables[`--tenant-${palette}-foreground`] = luminance > .179 ? '17 24 39' : '255 255 255';
    if (luminance > .179) variables[`--tenant-${palette}-text`] = channels.map((channel) => Math.round(channel * .35)).join(' ');

    for (const shade of [50, 100, 200, 300, 400, 500, 600, 700, 800, 900]) {
      const mix = shade < 600 ? ({ 50: .96, 100: .9, 200: .78, 300: .6, 400: .35, 500: .15 } as Record<number, number>)[shade] : (shade - 600) / 1000;
      const target = shade < 600 ? 255 : 0;
      variables[`--tenant-${palette}-${shade}`] = channels.map((channel) => Math.round(channel * (1 - mix) + target * mix)).join(' ');
    }
  }
  return variables;
}
